import $ from 'jquery';

var $window = $(window);

$.fn.center = function () { // http://stackoverflow.com/a/210733/166524
    this.css({
        position: 'absolute',
        top: Math.max(0, (($window.height() - this.outerHeight()) / 2) + $window.scrollTop())  + 'px',
        left: Math.max(0, (($window.width()  - this.outerWidth())  / 2) + $window.scrollLeft()) + 'px'
    });
    return this;
};
